export default __webpack_public_path__ + "static/media/project2-DJI_0449.a40a5e87.jpg";